module.exports = __webpack_public_path__ + "static/media/stirs.ffaf6777.jpg";